import React from "react";
import PropTypes from "prop-types";
import { formats } from "investira.sdk";

const FormatNumber = (props) => {
  const {
    value = 0,
    decimal = 6,
    separateThousand = true,
    showCurrency = false,
    sufix = "",
  } = props;

  return `${formats.formatNumber(
    value,
    decimal,
    separateThousand,
    showCurrency
  )}${sufix}`;
};

FormatNumber.propTypes = {
  value: PropTypes.number,
  decimal: PropTypes.number,
  separateThousand: PropTypes.bool,
  showCurrency: PropTypes.bool,
  sufix: PropTypes.string,
};

export default FormatNumber;
